import { render, staticRenderFns } from "./SlideNotification.vue?vue&type=template&id=797228fb&scoped=true"
import script from "./SlideNotification.vue?vue&type=script&lang=js"
export * from "./SlideNotification.vue?vue&type=script&lang=js"
import style0 from "./SlideNotification.vue?vue&type=style&index=0&id=797228fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797228fb",
  null
  
)

export default component.exports